// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"c_IY8IJLTKxWS8DuvKcs","notification":"erlm9L869Gh41TfGHIwI","notificationBulb":"EMbQxUfq1BwGS9A1lOi1"};